import React, { Component } from 'react';
import DisplayBlocks from './DisplayBlocks'
import LegalMentions from './LegalMentions'
import TextWithFieldname from '../texts/TextWithFieldname';
import TeaserPres from './TeaserPres';
import Dico from '../../helpers/Dico';
import ContMessageI18N from '../../containers/ContMessageI18N';
import ResultError from './ResultError';
import HelperGenerics from '../../helpers/HelperGenerics';

class Details extends Component {

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }
	getNbOccRenvoi(teaser) {
		var i = 0;
		if (teaser != null
			&& teaser.textConditions != null) {
			if (teaser.textConditions.regularPaymentConditions != null) {
				i++;
			}
			if (teaser.textConditions.primaryTextConditions != null) {
				i++;
			}
		}
		return i;
	}
	occRenvoiGlob = 1;
	render() {
		this.occRenvoiGlob = 1;
		var calculationResponse = this.props.vehicleDetails;
		return (
			<React.Fragment>
				{calculationResponse != null
					&& calculationResponse.hasError
					&& <ResultError
						responseObject={calculationResponse}
						settings={this.props.settings}
						vehicle={this.props.vehicle}
					/>
				}
				{calculationResponse != null
					&& !calculationResponse.hasError
					&& calculationResponse.result != null
					&& (calculationResponse.result.globalText != null || calculationResponse.result.displayBlocks != null)
					&& <React.Fragment>
						<div className="modal-header border-0" >
							<div className="container-fluid">
								<button type="button" className="btn-close float-end" data-bs-dismiss="modal" aria-label="Close" onMouseDown={(e) => e.currentTarget.blur()}></button>
								<div className="row shadow text-center m-auto">
									{calculationResponse.result && calculationResponse.result.globalText
										&& <TextWithFieldname fieldname="detailTitle" variant="h5" developperView={false}
											idTitle="modalDetailTitle">
											{calculationResponse.result.globalText.detailTitle != null
												? calculationResponse.result.globalText.detailTitle
												: Dico.getMessage(this.props.context.countryCode, this.props.context.languageCode, 'detailPage.result.title')}

										</TextWithFieldname>
									}
									{calculationResponse.result && calculationResponse.result.globalText
										&& <TextWithFieldname fieldname="detailSubTitle" variant="h6" developperView={false}>
											{calculationResponse.result.globalText.detailSubTitle}
										</TextWithFieldname>
									}
									{calculationResponse.result.globalText != null
										&& calculationResponse.result.globalText.validityText != null
										&& calculationResponse.result.globalText.validityText.map((line, index) => (
											<div className='float-end' key={index}>{line.text}</div>
										))}
								</div>
							</div>
						</div>
						<div className="container-fluid">
							<div className="row">
								{calculationResponse.result.displayBlocks != null
									&& <div className="col col-12 col-lg-6">
										{calculationResponse.result.globalText && calculationResponse.result.globalText.financialProductLabel
											&& <div className="shadow rounded p-2 m-2 text-center">
												<TextWithFieldname fieldname="financialProductLabel" variant="h6" developperView={false}>
													{calculationResponse.result.globalText.financialProductLabel.text}
												</TextWithFieldname>
											</div>
										}
										<DisplayBlocks data={calculationResponse.result.displayBlocks} />
									</div>
								}
								{calculationResponse.result.teaser != null
									&& <div className="col col-12 col-lg-6 order-first">
										<div className="row shadow rounded m-2">
											<TeaserPres
												vehicle={this.props.vehicle}
												settings={{ ...this.props.settings, process: 'summary', isDevelopperView: false }}
												teaser={calculationResponse.result.teaser}
												context={this.props.context}
												isDetail={true}
												occRenvoi={this.returnReference(this.getNbOccRenvoi(calculationResponse.result.teaser))}
											/>
										</div>
										<div className="row shadow rounded m-2">
											{calculationResponse.result.globalText && calculationResponse.result.globalText.detailInformationLink
												&& HelperGenerics.renderLink(calculationResponse.result.globalText.detailInformationLink.href,
													null, calculationResponse.result.globalText.detailInformationLink.text, 'btn btn-link text-start')
											}

										</div>
										{calculationResponse.result.teaser.textConditions != null && calculationResponse.result.teaser.textConditions.regularPaymentConditions != null
											&& <div className="row shadow rounded">
												{calculationResponse.result.teaser.textConditions.regularPaymentConditions.map((line, index) => (
													<TextWithFieldname fieldname="regularPaymentConditions" developperView={false} key={index}>
														{index === 0 && <React.Fragment >{this.renderReferenceAlone()}</React.Fragment >}
														{Dico.getTextWithArguments(line,
															calculationResponse.result.teaser.data,
															this.props.amountNature, this.props.context.countryCode, this.props.context.languageCode,
															calculationResponse.result.teaser.guide)}
													</TextWithFieldname>
												))}
											</div>
										}
									</div>
								}
							</div>
						</div>
						{calculationResponse.result.globalText != null
							&& <div className="modal-footer border-0" >
								<LegalMentions data={calculationResponse.result.globalText} />
							</div>
						}
					</React.Fragment>
				}
			</React.Fragment>
		)
	}

	renderReferenceAlone() {
		const occRenvoiIni = this.occRenvoiGlob;
		this.occRenvoiGlob++;
		return (
			<React.Fragment >({occRenvoiIni}) </React.Fragment >
		)
	}
	returnReference(nb) {
		const occRenvoiIni = this.occRenvoiGlob;
		this.occRenvoiGlob += nb;
		return occRenvoiIni;
	}
}

export default (Details)

